export default from './Tag';



// WEBPACK FOOTER //
// ./src/sharedComponents/Tag/index.js